import {useState} from "react";

function LessMoreComp({name,lessMr}) {
        const [lessMore, setLessMore] = useState({});
        const toggleLessMore = (lessMr) => {
            setLessMore(prev => ({
                ...prev,
                [lessMr]: !prev[lessMr]
              }));
        }
  return (
    <>
   {name && name?.length > 50 ? (
                <>
                    {lessMore[lessMr] ?
                        (<> {name} <span style={{ color: "#0e7fe1",cursor:'pointer' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleLessMore(lessMr); }}  > ..less </span> </>)
                        :
                        (<>{name.substring(0, 50)} <span style={{ color: "#0e7fe1",cursor:'pointer'}} onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleLessMore(lessMr); }}  > ..more </span> </>)
                    }
                </>
            ) : name || '--'
            }
        
    </>
  )
}

export default LessMoreComp